<template>
  <v-container>
    <v-alert color="success" v-if="successAlert">E-maily úspěšně odeslány</v-alert>
    <v-form v-model="formValid" ref="form">
      <h1 class="text-center">Emailing</h1>
      <v-row>
        <v-col>
          <v-select
            label="Vyberte typ"
            v-model="emailType"
            :items="emailTypes"
            outlined>
          </v-select>
        </v-col>
        <v-col>
          <v-select
            v-if="emailType === 3 || !emailType"
            disabled
            outlined
          ></v-select>
          <v-autocomplete
            v-else-if="emailType === 1"
            label="Vyberte instituci"
            v-model="form.institution"
            item-text="name"
            :items="institutions"
            return-object
            hide-selected
            persistent-hint
            small-chips
            outlined
            deletable-chips
          >
          </v-autocomplete>
          <v-autocomplete
            v-else
            multiple
            label="Vyberte e-maily"
            v-model="form.users"
            item-text="email"
            :items="users"
            hide-selected
            return-object
            persistent-hint
            small-chips
            outlined
            deletable-chips
          >
          </v-autocomplete>
        </v-col>
        <v-col>
          <v-autocomplete
            label="Vyberte jídelníček"
            v-model="form.diet"
            item-text="name"
            :items="diets"
            :disabled="form.customMessage"
            ref="dietInput"
            hide-selected
            return-object
            persistent-hint
            small-chips
            outlined
            deletable-chips
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="9">
          <v-text-field
            v-model="form.subject"
            outlined
            label="Zadejte předmět emailu"
            :rules="[rules.required]"
          >
          </v-text-field>
        </v-col>
        <v-col>
          <v-checkbox
            v-model="form.customMessage"
            label="Vlastní zpráva"
          >
          </v-checkbox>
        </v-col>
        <v-col cols="12" v-if="form.customMessage" >
          <TiptapVuetify v-model="form.customMessageText" :extensions="extensions"></TiptapVuetify>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn
            color="primary"
            class="text-center"
            @click="dialog = true"
            :disabled="!formValid"
          >
            Odeslat emaily
          </v-btn>
        </v-col>
      </v-row>
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title>Opravu si přejete odeslat emaily?</v-card-title>
          <div class="text-right pb-4 pr-4"><v-btn text color="gray" @click="dialog = false">Zrušit</v-btn>
            <v-btn
              @click="send"
              color="green"
              :disabled="sendMailsWait"
              :loading="sendMailsWait"
            >Odeslat</v-btn></div>
        </v-card>
      </v-dialog>
    </v-form>
  </v-container>
</template>

<script>
import rules from '@/mixins/rules'
import {
  TiptapVuetify,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History
} from 'tiptap-vuetify'

export default {
  components: { TiptapVuetify },
  name: 'EmailsForm',
  mixins: [rules],
  data () {
    return {
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        Bold,
        Link,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak
      ],
      sendMailsWait: false,
      formValid: true,
      successAlert: false,
      customEmails: ['email uzivatele'],
      emailType: 0,
      emailTypes: [{
        text: 'Všechny emaily',
        value: 0
      }, {
        text: 'Podle Instituce',
        value: 1
      }, {
        text: 'Vlastní',
        value: 2
      },
      {
        text: 'Pouze bez instituce',
        value: 3
      }],
      institutions: [],
      dietsAll: [],
      users: [],
      dialog: false,
      form: {
        customMessage: false,
        customMessageText: '',
        subject: '',
        institution: null,
        users: [],
        dietEmail: true
      }
    }
  },
  methods: {
    initialize () {
      this.$http.get('admin/roles/6')
        .then(res => {
          this.users = this.keysToCamelCase(res.data)
        })
      this.$http.get('admin/institutions')
        .then(res => {
          this.institutions = this.keysToCamelCase(res.data)
        })
      this.$http.get('admin/diets')
        .then(res => {
          this.dietsAll = this.keysToCamelCase(res.data)
        })
    },
    send () {
      if (!this.form.customMessage && !this.form.diet) {
        alert('Musí být vyplněný jídelníček')
        this.dialog = false
        return
      }
      this.sendMailsWait = true
      // let users
      // if (!this.emailType) {
      //   users = this.users
      // }
      // } else if (this.emailType === 1 || this.emailType === 3) {
      //   this.$http.get(`/admin/institution/${this.form.institution.id}/get-email-ids`)
      //     .then(response => {
      //       users = response.data
      //       console.log(users)
      //     }).catch(err => {
      //       console.log(err)
      //     })
      //   // users = this.users.filter(user => user.institutionId === this.form.institution.id)
      // } else {
      //   users = this.form.users
      // }

      const options = {
        type: this.emailType,
        subject: this.form.subject,
        customMessage: !!this.form.customMessage,
        customMessageText: this.form.customMessageText,
        userIds: this.form.users ? this.form.users.map(user => user.id) : [],
        dietId: this.form.customMessage ? null : this.form.diet.id,
        institutionId: this.emailType === 1 ? this.form.institution.id : null
      }
      this.$http.post('admin/emails/send', this.keysToSnakeCase(options))
        .then(res => {
          this.sendMailsWait = false
          this.dialog = false
          this.$refs.form.reset()
          this.form.customMessageText = ''
          this.showSuccessAlert()
        }).catch(() => {
          this.sendMailsWait = false
          this.dialog = false
        })
    },
    showSuccessAlert () {
      this.successAlert = true
      setTimeout(() => {
        this.successAlert = false
      }, 3000)
    }
  },
  computed: {
    diets () {
      if (this.emailType === 0 || this.emailType === 2) {
        return this.dietsAll.filter(diet => {
          // return diet if it is't institution diet
          // or each of selected users can order from it ( => same institution)
          if (diet.dietType !== 'Instituční') {
            return true
          } else {
            return this.form.users.every(user => user.institutionId === diet.institutionId) && diet.institutionId
          }
        })
      }
      if (!this.form.institution) {
        return []
      }
      return this.dietsAll.filter(diet => diet.institutionId === this.form.institution.id)
    }
  },
  created () {
    this.initialize()
  },
  watch: {
    diets (newArr) {
      if (!newArr.includes(this.form.diet)) {
        this.form.diet = null
        this.$refs.dietInput.reset()
      }
    }
  }
}
</script>

<style scoped>

</style>
